<template>
    <div v-if="panier" class="el-menu-item carton ">
        <h1>Votre Carton</h1>
        <div class="box">
            <template v-for="(bouteille, i) in panier.bouteilles">
                <el-col
                    v-for="q in bouteille.pivot.quantite"
                    :span="4"
                    :key="'boutbox_' + i + '_' + q"
                    class="bouteillebox"
                >
                    <el-tooltip
                        :content="bouteille.vin.nom + ' ' + bouteille.millesime"
                    >
                        <el-image
                            class="bouteille"
                            :src="
                                bouteille.photo
                                    ? bouteille.photo_url.thumb
                                    : '/storage/bouteilles_thumb/vide.jpg'
                            "
                            fit="scale-down"
                        />
                    </el-tooltip>
                </el-col>
            </template>
            <template v-if="panier.max > panier.nbbouteilles">
                <template v-for="i in panier.max - panier.nbbouteilles">
                    <el-col :span="4" :key="'vide_' + i" class="bouteillebox">
                        <div class="bouteille" />
                    </el-col>
                </template>
            </template>
        </div>
        <div class="linecarton">
            <!--<h3>Total {{ panier.totalBouteillesHT | formatPrix }} € HT</h3>-->
            <div class="prixline">
                <span class="label">
                    Prix
                </span>
                <span class="value">
                    {{ panier.totalBouteillesTTC | formatPrix }} € TTC
                </span>
            </div>
            <div class="prixline" v-loading="loading">
                <span class="label">
                    Livraison
                </span>
                <el-tooltip :content="tooltiplivraison()">
                    <span class="value" v-if="panier.livraisonttc >= 0">
                        {{ panier.livraisonttc | formatPrix }} € TTC
                    </span>
                    <span class="value" v-else>
                        {{ panier.livraisonexp }}
                    </span>
                </el-tooltip>
            </div>
            <div class="prixline" v-if="panier.etat == 'encours'">
                <el-tooltip
                    :content="
                        'Vous venez chercher le colis au Domaine si coché'
                    "
                >
                    <el-checkbox
                        @change="livdomaineUpdate"
                        v-model="livdomaine"
                    >
                        sans livraison
                    </el-checkbox>
                </el-tooltip>
            </div>
            <div
                class="prixline"
                v-if="panier.etat != 'encours' && panier.livdomaine === 1"
            >
                <el-tooltip
                    :content="'Vous venez chercher le colis au Domaine'"
                >
                    <span>sans livraison</span>
                </el-tooltip>
            </div>

            <div class="prixline">
                <span class="label">
                    Total
                </span>
                <span class="value">
                    {{ panier.totalttc | formatPrix }} € TTC
                </span>
            </div>
        </div>
        <div class="linecarton">
            <span v-if="panier.etat == 'avalider'">
                Allocation en cours de validation
            </span>
            <span v-else-if="panier.etat == 'valided'">
                Allocation en attente de paiement
            </span>
            <span v-else-if="panier.etat == 'payed'">
                Allocation en préparation
            </span>
            <span v-else-if="panier.etat == 'livred'">
                Allocation en livraison
            </span>
            <el-button
                v-else
                type="danger"
                class="button"
                @click.native.prevent="handleSendpanier"
            >
                Valider votre allocation
            </el-button>
            <div class="finvalidation" v-if="panier.etat == 'encours'">
                Validation avant le {{ panier.fin_allocation | formatDate }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Resource from "@/api/resource";
const panierResource = new Resource("paniers");

export default {
    name: "Carton",
    props: {},
    data() {
        return {
            charteVisible: false,
            sending: false,
            sended: false,
            livdomaine: false,
            loading: false
        };
    },
    created() {},
    watch: {
        panier() {
            this.livdomaine = !!this.panier.livdomaine;
        }
    },
    computed: {
        ...mapState({
            panier: state => state.user.panier,
            sendpanier: state => state.app.sendpanier
        })
    },
    methods: {
        tooltiplivraison() {
            if (this.panier.livraisonttc === -2) {
                return (
                    "La livraison vers votre département doit se faire sur devis (" +
                    this.panier.livraison_adresse_label +
                    ")"
                );
            }
            if (this.panier.livraisonttc === -1) {
                return "Vous n'avez pas d’adresse de livraison";
            }
            if (this.panier.livdomaine === 1) {
                return "Vous venez chercher le colis au Domaine";
            }
            return (
                "Adresse de livraison : " + this.panier.livraison_adresse_label
            );
        },
        handleSendpanier() {
            this.$store.dispatch("app/setSendpanier", true);
        },
        livdomaineUpdate() {
            var ld = this.livdomaine ? 1 : 0;
            this.loading = true;
            panierResource
                .update(this.panier.id, { livdomaine: ld })
                .then(response => {
                    this.$message({
                        message: response.message
                            ? response.message
                            : "modification faite",
                        type: response.message ? "error" : "success",
                        duration: 2 * 1000
                    });
                    if (response.data && response.data.id) {
                        // this.panier = response.data;
                        this.$store.dispatch("user/setPanier", response.data);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.$message({
                        message: "Erreur",
                        type: "error",
                        duration: 2 * 1000
                    });
                    this.loading = false;
                });
        }
    }
};
</script>
